import { Component, Input, OnInit } from "@angular/core";
import { VisualizationOptionsType } from "@arch/_shared/types/options-visualization";
import { FormatNumbers } from "@arch/_shared/utils/format-number.utils";
import {
    CompanyEntity,
    PointEntity,
    SerieEntity,
    VisualizationEntity
} from "@arch/domain/entity";
import { HighchartsRenderComponent } from "../../highcharts-render/highcharts-render.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";

@Component({
    selector: "app-special-chart-column-comparation",
    imports: [HighchartsRenderComponent, FlexLayoutModule, SharedDsnModule],
    templateUrl: "./special-chart-column-comparation.component.html",
    styleUrl: "./special-chart-column-comparation.component.scss"
})
export class SpecialChartColumnComparationComponent implements OnInit {
    @Input() visualization!: VisualizationEntity;
    @Input() options!: VisualizationOptionsType;
    @Input() series!: SerieEntity[];
    @Input() company!: CompanyEntity;
    @Input() points!: PointEntity[];

    ngOnInit(): void {
        this.setStructureChart();
    }

    private setStructureChart(): void {
        const isAnalysisPlus =
            this.options.comparation.active ||
            this.options.budget ||
            this.options.projection ||
            this.options.goals;

        const configs = this.visualization.props?.component?.configs;
        const series = configs.series.map((serie: any) => {
            if (isAnalysisPlus) {
                delete serie.stack;
            }
            return serie;
        });

        const formatValue = FormatNumbers.byUnit;

        const structure = {
            category: "columncomparation",
            chart: {
                reflow: true
            },
            tooltip: {
                formatter: function (this: any) {
                    const key = this.key;
                    return `${key}: ${formatValue("currency", this.y, 2)}`;
                }
            },
            series: series,
            yAxis: {
                title: {
                    text: ""
                }
            },
            legend: {
                enabled: false
            },
            xAxis: {
                categories: ["TOTAL DE RECURSOS"],
                title: {
                    text: ""
                },

                labels: {
                    enabled: false
                },
                lineWidth: 0,
                tickLength: 0
            },
            goals: {},
            labels: {
                items: [
                    {
                        style: {
                            left: "50px",
                            top: "18px",
                            color: "rgb(48, 206, 212)"
                        }
                    }
                ]
            },
            plotOptions: {
                column: {
                    stacking: isAnalysisPlus ? null : "normal",
                    cursor: "pointer"
                }
            }
        };

        if (
            this.options.goals &&
            this.visualization.props?.component?.configs?.goals?.length
        ) {
            structure.goals =
                this.visualization.props?.component?.configs?.goals;
        }

        this.visualization.setChartConfiguration(structure);
    }
}

export interface ISpecialChartColumnComparationComponent {
    series: SerieEntity[];
    points: PointEntity[];
    visualization: VisualizationEntity;
    options: VisualizationOptionsType;
    company?: CompanyEntity;
}
